export const Material = {
  Activo: true,
  Codigo: null,
  CodigoAdicional: null,
  CodigoFamilia: null,
  CodigoMaterialTipo: null,
  CodigoMoneda: null,
  CodigoUnidadMedida: null,
  CodigoUsuarioActualizacion: null,
  CodigoUsuarioCreacion: null,
  Costo: null,
  Descripcion: null,
  FechaActualizacion: null,
  FechaCreacion: null,
};

export const Forma = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};

export const initialFilterSwage = {
  Activo: true,
  CodigoSuaje: null,
  CodigoAdicional: null,
  Descripcion: null,
  Observaciones: null,
  Busqueda: null,
  MedidaEje: null,
  MedidaDesarrollo: null,
  CodigoSuajeTipo: null,
  Pleca: null,
  Forma,
  Material,
  Tolerancia: 3,
  UnidadMedida: 'mm',
  CodigoMateriaPrimaFamilia: null,
};

export const Suaje = {
  Activo: true,
  AnchoOptimoMaterial: null,
  Codigo: null,
  CodigoClaseSuaje: null,
  CodigoForma: null,
  CodigoMaterial: null,
  CodigoSuaje: null,
  CodigoAdicional: null,
  Descripcion: null,
  Observaciones: null,
  CodigoSuajeTipo: null,
  CodigoUsuarioActualizacion: null,
  CodigoUsuarioCreacion: null,
  CotizacionElemento: [],
  Desarrollo: null,
  Engranaje: null,
  EtiquetasDesarrollo: null,
  EtiquetasEje: null,
  FechaActualizacion: null,
  FechaCreacion: null,
  Forma: structuredClone(Forma),
  GapDesarrolloIn: null,
  GapDesarrolloMm: null,
  GapEjeIn: null,
  GapEjeMm: null,
  MedidaDesarrolloIn: null,
  MedidaDesarrolloMm: null,
  MedidaEjeIn: null,
  MedidaEjeMm: null,
  SolicitudElemento: [],
  TienePleca: false,
  EsAutomatica: false,
  EsCorteCompleto: false,
  MinEtiquetaImpresa: null,
  MinEtiquetaSinImpresion: null,
  Material,
  SuajeMateriaPrimaFamilia: [],
};
